"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridResizeIndicator = void 0;
const react_1 = __importDefault(require("react"));
const GridResizeIndicator_styles_1 = require("./GridResizeIndicator.styles");
exports.GridResizeIndicator = react_1.default.memo(function GridResizeIndicator() {
    return (react_1.default.createElement(GridResizeIndicator_styles_1.StyledGridResizeIndicator, { "data-selector-id": "grid-core-resize-indicator", className: "vm-GridResizeIndicator" }));
});
//# sourceMappingURL=GridResizeIndicator.js.map